import apiClient from '../client'

export interface RecurringMessageResponse {
  id: string
  created_by_id: string
  parish_id: string
  subject: string | null
  body: string
  to_user_id: string | null
  recipient_type: 'all_parents' | 'all_teachers' | 'all_users' | 'class' | 'specific_users'
  recipient_ids: string | null  // JSON string of array
  frequency: 'daily' | 'weekly' | 'monthly'
  interval: number
  start_date: string
  end_date: string | null
  day_of_week: number | null  // 0-6 (0=Monday, 6=Sunday)
  day_of_month: number | null  // 1-31
  send_time: string  // HH:MM format
  is_active: boolean
  last_sent_at: string | null
  next_send_at: string | null
  total_sent: number
  created_at: string
  updated_at: string
}

export interface RecurringMessageCreate {
  subject?: string | null
  body: string
  to_user_id?: string | null
  recipient_type?: 'all_parents' | 'all_teachers' | 'all_users' | 'class' | 'specific_users'
  recipient_ids?: string[] | null
  frequency: 'daily' | 'weekly' | 'monthly'
  interval?: number
  start_date: string  // ISO datetime string
  end_date?: string | null  // ISO datetime string
  day_of_week?: number | null
  day_of_month?: number | null
  send_time?: string  // HH:MM format
}

export interface RecurringMessageUpdate {
  subject?: string | null
  body?: string
  to_user_id?: string | null
  recipient_type?: 'all_parents' | 'all_teachers' | 'all_users' | 'class' | 'specific_users'
  recipient_ids?: string[] | null
  frequency?: 'daily' | 'weekly' | 'monthly'
  interval?: number
  start_date?: string
  end_date?: string | null
  day_of_week?: number | null
  day_of_month?: number | null
  send_time?: string
  is_active?: boolean
}

export const recurringMessagesApi = {
  list: async (activeOnly: boolean = false): Promise<RecurringMessageResponse[]> => {
    const response = await apiClient.get<RecurringMessageResponse[]>('/recurring-messages/', {
      params: { active_only: activeOnly }
    })
    return response.data
  },

  get: async (id: string): Promise<RecurringMessageResponse> => {
    const response = await apiClient.get<RecurringMessageResponse>(`/recurring-messages/${id}`)
    return response.data
  },

  create: async (data: RecurringMessageCreate): Promise<RecurringMessageResponse> => {
    const response = await apiClient.post<RecurringMessageResponse>('/recurring-messages/', data)
    return response.data
  },

  update: async (id: string, data: RecurringMessageUpdate): Promise<RecurringMessageResponse> => {
    const response = await apiClient.put<RecurringMessageResponse>(`/recurring-messages/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/recurring-messages/${id}`)
  },
}

